import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  sidebar: false,
  links: [
    {
      title: 'Каталог',
      icon: 'mdi-store',
      to: 'catalog'
    },
    {
      title: 'Документы',
      icon: 'mdi-briefcase-outline',
      to: 'documents'
    },
    {
      title: 'Заказы',
      icon: 'mdi-chart-line',
      to: 'balance'
    },
    {
      title: 'Прайс-лист',
      icon: 'mdi-file-download',
      to: 'pricelist'
    }
    // ,
    // {
    //   title: 'Контакты',
    //   icon: 'mdi-contacts',
    //   to: 'contacts'
    // }
  ]
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
